import * as Yup from "yup";

export const RowBlockSchema = Yup.object().shape({
    table_name: Yup.string().required("Пожалуйста, укажите название таблицы"),
    username: Yup.string().required("Пожалуйста, укажите логин пользователя"),
    e_id: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .required("Пожалуйста, укажите сущность"),
});
